import {
  type EncodeStatus,
  hasSuccessfulTranscodes,
} from '@frameio/shared/transfers/utils/hasSuccessfulTranscodes';
import type { TranscodeProgressFragment } from '../gql/generated/TranscodeProgress';

export type AssetWithMultipleTranscodes =
  | Extract<TranscodeProgressFragment, { __typename?: 'AudioAsset' }>
  | Extract<TranscodeProgressFragment, { __typename?: 'ImageAsset' }>
  | Extract<TranscodeProgressFragment, { __typename?: 'VideoAsset' }>
  | Extract<TranscodeProgressFragment, { __typename?: 'ModelAsset' }>
  | Extract<TranscodeProgressFragment, { __typename?: 'InteractiveAsset' }>;

export function assetHasAnyTranscode(asset: AssetWithMultipleTranscodes) {
  let transcodes: EncodeStatus[] = [];

  switch (asset.__typename) {
    case 'AudioAsset':
      transcodes = asset.media?.audioTranscodes ?? [];
      break;
    case 'ImageAsset':
      transcodes = asset.media?.imageTranscodes ?? [];
      break;
    case 'VideoAsset':
    case 'ModelAsset':
      transcodes = asset.media?.videoTranscodes ?? [];
      break;
    case 'InteractiveAsset':
      transcodes = asset.media?.interactiveTranscodes ?? [];
      break;
    default:
      break;
  }

  return hasSuccessfulTranscodes(transcodes);
}
